export default {
  dev: 'https://io.popsup.dev.joidea.com/',
  prod: 'https://io.menu.popsup.global/',
  unset: 'unset',
};
